<template>
    <transition name="fade">
        <div class="container">
            <h3 class="text-center text-secondary">Error 404! Sorry the page you are looking for could not be found!!!</h3>
        </div>
    </transition>
</template>
<script>
export default {};
</script>
